import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './components/Toast';
import Navbar from './components/Navbar';
import Companies from './pages/Companies';
import Parties from './pages/Parties';
import Bills from './pages/Bills';
import Payments from './pages/Payments';
import Reports from './pages/Reports';
import Dashboard from './pages/Dashboard';

function App() {
  return (
    <ToastProvider>
      <Router>
        <div className="min-h-screen bg-brand-50">
          <Navbar />
          {/* Main content: offset for sidebar on desktop, padding for bottom nav on mobile */}
          <main className="lg:ml-60 pb-20 lg:pb-0">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
              <Routes>
                <Route path="/" element={<Bills />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/companies" element={<Companies />} />
                <Route path="/parties" element={<Parties />} />
                <Route path="/bills" element={<Bills />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/reports" element={<Reports />} />
              </Routes>
            </div>
          </main>
        </div>
      </Router>
    </ToastProvider>
  );
}

export default App;
